export default {
  common: {
    companyName: 'Changzhou Xinghongda Electrical Technology Co.,Ltd.',
    nav: {
      home: 'Home',
      about: 'About Us',
      partners: 'Partners',
      equipment: 'Equipment',
      product: 'Products',
      specs: 'Specifications',
      contact: 'Contact Us'
    },
    home: {
      coreAdvantages: 'Core Advantages',
      strictProcess: 'Strict Process Standards',
      excellentQuality: 'Crafting Excellent Quality'
    },
    about: {
      title: 'About Xinghongda',
      introTitle: 'Company Profile',
      spiritTitle: 'Corporate Spirit',
      honorTitle: 'Certifications',
      honorSubtitle: 'Global Certifications, Quality Assured'
    },
    partners: {
      bannerTitle: 'Global Trust, Driving Industry Upgrade',
      bannerDesc: 'With a stable delivery record and a pursuit of zero-defect quality, we have become a long-term supplier for many well-known domestic and international manufacturers.',
      applicationTitle: 'Application Fields',
      partnerTitle: 'Partners',
      partnerSubtitle: 'Forging long-term strategic cooperation with industry leaders',
      commitTitle: 'Quality Commitment',
      commitDesc1: 'We understand that in precision manufacturing, every detail affects the final performance of the product. Therefore, we have established a strict quality management system, from raw material procurement to finished product delivery, every step undergoes rigorous inspection and control.',
      commitDesc2: 'Through long-term cooperation with global leaders, we continuously optimize product performance and improve service levels, ensuring stable and reliable products and efficient technical support for our customers.',
      zeroDefect: 'Zero Defect',
      qualityTarget: 'Quality Target',
      timeliness: 'Timeliness',
      techSupport: 'Technical Support',
      customization: 'Customization',
      solutions: 'Solutions',
      fullCoverage: 'Full Coverage',
      serviceNetwork: 'Service Network'
    },
    equipment: {
      bannerTitle: 'Precision Manufacturing, from Hardcore Equipment',
      bannerSubtitle: 'To do a good job, one must first sharpen one\'s tools.',
      bannerDesc: 'Xinghongda introduces advanced ultra-fine wire drawing machines, annealing coating machines, and online inspection systems to ensure product quality with leading equipment.',
      coreEquip: 'Core Equipment',
      coreEquipSubtitle: 'Internationally advanced production & testing equipment',
      techAdvantage: 'Technical Advantages',
      techAdvantageSubtitle: 'Automation & Digital Transformation Ensures Product Consistency and Stability',
      smartIdea: 'Smart Manufacturing Philosophy',
      smartDesc1: 'We are committed to ensuring consistency in wire diameter tolerance and stability in film strength under high-speed production through automation and digital transformation.',
      smartDesc2: 'From raw material entry to finished product delivery, every step is monitored by intelligent systems, achieving full visualization and data-based management of the production process.'
    },
    product: {
      categoryTitle: 'Product Categories',
      specsTitle: 'Product Specifications',
      specsDesc: ''
    },
    footer: {
      description1: 'Professional Manufacturer Specializing in Ultra-Fine & Special Enameled Wires',
      description2: 'Dedicated to Supplying High-performance, High-reliability Enameled Wires for Global Clients',
      contactTitle: 'Contact Information',
      addressLabel: 'Address: ',
      addressValue: 'No.8 Tianjing Road, Luoyang Town, Wujin District, Changzhou, Jiangsu',
      hotlineLabel: 'Service Hotline: ',
      emailLabel: 'Email: ',
      copyright: '© 2026 Changzhou Xinghongda Electrical Technology Co.,Ltd.. All Rights Reserved'
    },
    contact: {
      title: 'Online Inquiry',
      subtitle: 'Complete the form below, and you will receive our reply within 24 hours.',
      form: {
        companyName: 'Company Name',
        companyNamePlaceholder: 'Please enter company name',
        contactPerson: 'Contact Person',
        contactPersonPlaceholder: 'Please enter contact person',
        phone: 'Phone Number',
        phonePlaceholder: 'Please enter phone number',
        email: 'Email Address',
        emailPlaceholder: 'Please enter email address',
        modelRequest: 'Model Request',
        modelRequestPlaceholder: 'Please enter model request',
        specsRequest: 'Diameter Request',
        specsPlaceholder: 'e.g., Wire diameter 0.05mm, Grade 2',
        quantity: 'Estimated Quantity',
        quantityPlaceholder: 'e.g., 1000kg/month',
        application: 'Application',
        applicationPlaceholder: 'e.g., EV motors, consumer electronics, etc.',
        detail: 'Detailed Requirements',
        detailPlaceholder: 'Please describe your requirements in detail, including special performance, delivery time, etc.',
        privacyTitle: 'Privacy Statement',
        privacyText: 'Information provided by you shall only be utilized for business correspondence. We guarantee strict confidentiality and shall not disclose such information to any external third parties without authorization.',
        submit: 'Submit Inquiry',
        submitting: 'Submitting...',
        success: 'Thank you for your inquiry! Our staff will contact you shortly.',
        fail: 'Submission failed, please try again later',
        error: 'An error occurred during submission, please check your network'
      },
      factoryTitle: 'Factory Location'
    }
  }
}
